import React, { useMemo } from 'react'
import { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import {
  arePropertyRatesLoading,
  getPropertyCombinedRatesByRoom,
  getPropertyMappedBedbankOffer,
  getPropertySelectedRoomCombinedRates,
} from 'selectors/offerPage/offerPageSelectors'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import PropertyRoomOptionMobile from 'components/OfferPage/Property/MobileBookingFlow/PropertyRoomOptionMobile'
import uuidV4 from 'lib/string/uuidV4Utils'
import type { RoomRateViews } from 'components/OfferPage/Property/singlePropertyUtils'
import AlwaysOnMobileStickyHeaderFilters from '../AlwaysOnMobileStickyHeaderFilters'

interface Props {
  offer: App.HotelOffer
  bedbankOffer?: App.BedbankOffer
  selectedRoom: RoomRateViews | undefined
  combinedRatesByRoom: Array<RoomRateViews>
  airports?: Array<App.Airport>
  isLoading: boolean
  onClose?: () => void
  onBack?: () => void
}

function SinglePropertyPackageSelectionModal(props: Props) {
  const {
    offer,
    bedbankOffer,
    selectedRoom,
    combinedRatesByRoom,
    airports,
    isLoading,
    onClose,
    onBack,
  } = props

  /************************************************************************************************/
  /* STOP! Do not add any more hooks for deriving packages/rooms or options/rates to this         */
  /* component! This logic is being refactored out into selectors! If you _need_ to add new       */
  /* logic, speak to Xiao or Robert.                                                              */
  /************************************************************************************************/

  const destinationAirport = useMemo(() => airports?.find(({ code }) => code === offer.flightDestinationPort), [airports, offer.flightDestinationPort])

  const roomListId = useMemo(() => uuidV4(),
  // eslint-disable-next-line react-hooks/exhaustive-deps
    [combinedRatesByRoom]) // regenerate id if list of rooms changes

  return (
    <>
      <ModalHeader
        title="Select a package"
        onCloseButtonClick={onClose}
        onBackButtonClick={onBack}
      >
        <AlwaysOnMobileStickyHeaderFilters />
      </ModalHeader>
      <ModalBody>
        {selectedRoom && <PropertyRoomOptionMobile
          offer={offer}
          bedbankOffer={bedbankOffer}
          displayRates={selectedRoom.displayRates}
          roomFitsCapacity={selectedRoom.roomFitsCapacity}
          datesAvailable={selectedRoom.datesAvailable}
          flightDestination={destinationAirport}
          isHighlighted={selectedRoom.isHighlighted}
          roomRateUnmatched={selectedRoom.roomRateUnmatched}
          roomListId={roomListId}
        />}
        {isLoading && <LoadingIndicator inline />}
      </ModalBody>
    </>
  )
}

export default withOfferPageAndReduxState((state: OfferPageState, appState: App.State) => ({
  offer: state.offer,
  bedbankOffer: getPropertyMappedBedbankOffer(state, appState),
  selectedRoom: getPropertySelectedRoomCombinedRates(state, appState),
  combinedRatesByRoom: getPropertyCombinedRatesByRoom(state, appState),
  airports: appState.geo.airports,
  isLoading: arePropertyRatesLoading(state, appState),
}), SinglePropertyPackageSelectionModal)
